"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityHexStringCodec = void 0;
const protocol_core_1 = require("@moojo/protocol-core");
const sdk_error_1 = require("../sdk-error");
const stable_stringify_1 = require("../utils/stable-stringify");
const resolve_codec_error_1 = require("./resolve-codec-error");
/**
 * Encodes and decodes objects by given parsing schema to and from hex strings.
 * This codec is mostly used for data interactions with on-chain smart contracts.
 *
 * TODO:
 * use more efficient serialization (protobufs?)
 */
exports.entityHexStringCodec = {
    toHexString: (data, parser) => {
        try {
            const parsed = parser.parse(data);
            const json = (0, stable_stringify_1.stableStringify)(parsed);
            if (!json) {
                throw new sdk_error_1.SdkError('data_encoding_error', 'Serialization failed');
            }
            return (0, protocol_core_1.hexify)(Buffer.from(json, 'utf-8').toString('hex'));
        }
        catch (e) {
            throw (0, resolve_codec_error_1.resolveCodecError)(e);
        }
    },
    fromHexString: (hexData, parser) => {
        try {
            const json = Buffer.from((0, protocol_core_1.dehexify)(hexData), 'hex').toString('utf-8');
            return parser.parse(JSON.parse(json));
        }
        catch (e) {
            throw (0, resolve_codec_error_1.resolveCodecError)(e);
        }
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGV4LXN0cmluZy1jb2RlYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb2RlYy9oZXgtc3RyaW5nLWNvZGVjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHdEQUFrRTtBQUVsRSw0Q0FBdUM7QUFDdkMsZ0VBQTJEO0FBQzNELCtEQUF5RDtBQUV6RDs7Ozs7O0dBTUc7QUFDVSxRQUFBLG9CQUFvQixHQUFHO0lBQ2xDLFdBQVcsRUFBRSxDQUFJLElBQU8sRUFBRSxNQUFtQixFQUFhLEVBQUU7UUFDMUQsSUFBSSxDQUFDO1lBQ0gsTUFBTSxNQUFNLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQTtZQUNqQyxNQUFNLElBQUksR0FBRyxJQUFBLGtDQUFlLEVBQUMsTUFBTSxDQUFDLENBQUE7WUFDcEMsSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDO2dCQUNWLE1BQU0sSUFBSSxvQkFBUSxDQUFDLHFCQUFxQixFQUFFLHNCQUFzQixDQUFDLENBQUE7WUFDbkUsQ0FBQztZQUVELE9BQU8sSUFBQSxzQkFBTSxFQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFBO1FBQzNELENBQUM7UUFBQyxPQUFPLENBQUMsRUFBRSxDQUFDO1lBQ1gsTUFBTSxJQUFBLHVDQUFpQixFQUFDLENBQUMsQ0FBQyxDQUFBO1FBQzVCLENBQUM7SUFDSCxDQUFDO0lBRUQsYUFBYSxFQUFFLENBQUksT0FBa0IsRUFBRSxNQUFtQixFQUFLLEVBQUU7UUFDL0QsSUFBSSxDQUFDO1lBQ0gsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFBLHdCQUFRLEVBQUMsT0FBTyxDQUFDLEVBQUUsS0FBSyxDQUFDLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUFBO1lBQ3BFLE9BQU8sTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUE7UUFDdkMsQ0FBQztRQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7WUFDWCxNQUFNLElBQUEsdUNBQWlCLEVBQUMsQ0FBQyxDQUFDLENBQUE7UUFDNUIsQ0FBQztJQUNILENBQUM7Q0FDRixDQUFBIn0=